// ============================================================
// cf-datatable.js � Reusable DataTable helper
// Load hanya pada halaman yang menggunakan DataTable.
//
// Dependencies: site.js (CF.appConfig), jQuery, DataTables
//
// Auto-injects (tidak perlu ditulis di cshtml):
//   - table-toolbar-top  (search, columns toggle, filter btn, actions dropdown)
//   - filter-bar         (active filter chips)
//   - row-ctx-menu       (row context menu)
//   - table-toolbar-bottom (page size, row info, pagination)
//
// Yang TETAP ditulis di cshtml:
//   - <table> dengan <thead> (nama kolom)
//   - filter modal body (#filter-body) � custom form fields
//
// Usage (client-side):
//   var dt = CF.dataTable.init('#myTable', { data: [...], columns: [...] });
//
// Usage (server-side):
//   var dt = CF.dataTable.serverInit('#myTable', {
//       columns: [...],
//       actions: [...],
//       rowActions: [...],
//       onRowAction: function(action, rowData) { ... },
//       mapItem: function(item) { return [item.name, item.code, ...]; },
//       loadFn: function(params, handle) {
//           CF.auth.api({ url: '/api/v1/roles/list?' + qs }).then(function(res) {
//               handle.loaded(res.data.items, res.data.pagination);
//           });
//       }
//   });
//   dt.reload({ page: 1 });
//
// Column width strategy:
//   - width (%)   ? distribusi proporsional saat container lebar
//   - minWidth    ? batas bawah per kolom; .table-wrap scroll
// ============================================================

window.CF = window.CF || {};

(function () {
    'use strict';

    var _tableCounter = 0;
    var _registry = {};

    // ????????????????????????????????????????????????????????
    // CF.dataTable
    // ????????????????????????????????????????????????????????
    CF.dataTable = (function () {

        // ?? Pagination helpers ??????????????????????????????
        function _pageRangeArr(cur, total) {
            if (total <= 7) return Array.from({ length: total }, function (_, i) { return i; });
            if (cur < 4) return [0, 1, 2, 3, 4, '\u2026', total - 1];
            if (cur > total - 5) return [0, '\u2026', total - 5, total - 4, total - 3, total - 2, total - 1];
            return [0, '\u2026', cur - 1, cur, cur + 1, '\u2026', total - 1];
        }

        function _renderFooter(dtInstance, footerIds) {
            if (!dtInstance) return;

            var info       = dtInstance.page.info();
            var cur        = info.page;
            var total      = info.pages;
            var totalCount = info.recordsDisplay;
            var start      = totalCount === 0 ? 0 : info.start + 1;
            var end        = info.end;

            var rowInfoEl = document.getElementById(footerIds.rowInfoId);
            if (rowInfoEl) {
                var filteredNote = info.recordsTotal !== totalCount
                    ? ' (filtered from ' + info.recordsTotal + ')'
                    : '';
                rowInfoEl.textContent = 'Showing ' + start + '\u2013' + end +
                    ' of ' + totalCount + ' entries' + filteredNote;
            }

            var wrap = document.getElementById(footerIds.paginationWrapId);
            if (!wrap) return;

            var uid  = footerIds._uid;
            var btns = '';
            btns += '<button class="pg-btn' + (cur === 0 ? ' disabled' : '') + '" onclick="CF.dataTable._goPage(' + uid + ',0)" title="First"><i class="fa-solid fa-angles-left"></i></button>';
            btns += '<button class="pg-btn' + (cur === 0 ? ' disabled' : '') + '" onclick="CF.dataTable._goPage(' + uid + ',' + (cur - 1) + ')" title="Prev"><i class="fa-solid fa-angle-left"></i></button>';

            _pageRangeArr(cur, total).forEach(function (p) {
                if (p === '\u2026') { btns += '<button class="pg-btn ellipsis">\u2026</button>'; return; }
                btns += '<button class="pg-btn' + (p === cur ? ' active' : '') +
                    '" onclick="CF.dataTable._goPage(' + uid + ',' + p + ')">' + (p + 1) + '</button>';
            });

            btns += '<button class="pg-btn' + (cur >= total - 1 || total === 0 ? ' disabled' : '') + '" onclick="CF.dataTable._goPage(' + uid + ',' + (cur + 1) + ')" title="Next"><i class="fa-solid fa-angle-right"></i></button>';
            btns += '<button class="pg-btn' + (cur >= total - 1 || total === 0 ? ' disabled' : '') + '" onclick="CF.dataTable._goPage(' + uid + ',' + (total - 1) + ')" title="Last"><i class="fa-solid fa-angles-right"></i></button>';

            wrap.innerHTML = btns;
        }

        function _buildPageSizeSelect(selectId, currentSize) {
            var el = document.getElementById(selectId);
            if (!el) return;
            var options = CF.appConfig.pagination.pageSizeOptions;
            el.innerHTML = '';
            options.forEach(function (size) {
                var opt = document.createElement('option');
                opt.value       = size;
                opt.textContent = size;
                if (size === currentSize) opt.selected = true;
                el.appendChild(opt);
            });
        }

        // ?? Inject toolbar top ??????????????????????????????
        // Search + Column Toggle + Filter btn + Primary Action btn + Actions dropdown
        //
        // If .table-toolbar-top already exists in the cshtml, adopt it
        // by wiring up event handlers via data-cf-* attributes.
        // Otherwise fall back to auto-generating the toolbar.
        function _injectToolbarTop(card, uid, columns, actions, injectOpts) {
            var existingToolbar = card.querySelector('.table-toolbar-top');
            if (existingToolbar) {
                _adoptToolbarTop(existingToolbar, uid, columns, actions, injectOpts);
                return;
            }

            // ?? Auto-generate toolbar ????????????????????????
            var colPopupId    = 'dt-col-popup-' + uid;
            var actPopupId    = 'dt-act-popup-' + uid;
            var searchId      = 'dt-search-'    + uid;
            var primaryAction = injectOpts && injectOpts._primaryAction;

            // Column toggle items
            var tableEl     = card.querySelector('table');
            var headerCells = tableEl ? tableEl.querySelectorAll('thead th') : [];
            var colItems    = '';
            columns.forEach(function (col, i) {
                var thEl  = headerCells[i];
                var title = (thEl ? thEl.textContent.trim() : '') || col.title || '';
                if (!title) return;
                colItems += '<label class="col-toggle-item">' +
                    '<input type="checkbox" checked onchange="CF.dataTable._toggleColumn(' + uid + ',' + i + ',this.checked)" />' +
                    title +
                '</label>';
            });

            // Actions dropdown items
            var actItems = '';
            if (actions && actions.length) {
                actions.forEach(function (a, idx) {
                    if (a.divider) {
                        actItems += '<div class="pm-divider"></div>';
                    } else {
                        // permission attribute lets CF.permission.applyGuards
                        // hide entries the user can't perform after CF.user loads.
                        var permAttr = a.permission
                            ? ' data-cf-permission="' + a.permission + '"'
                            : '';
                        actItems += '<div class="pm-item' + (a.danger ? ' danger' : '') + '"' + permAttr +
                            ' onclick="CF.dataTable._onAction(' + uid + ',' + idx + ')">' +
                            '<span class="pm-icon"><i class="' + (a.icon || '') + '"></i></span>' +
                            a.label +
                        '</div>';
                    }
                });
            }

            // Actions button (only if there are non-divider items)
            var hasActions = actions && actions.some(function (a) { return !a.divider; });
            var actionsBtn = '';
            if (hasActions) {
                actionsBtn =
                    '<div class="popup-wrap">' +
                        '<button class="tb-btn tb-btn-secondary" onclick="togglePopup(\'' + actPopupId + '\')">' +
                            'Actions <i class="fa-solid fa-chevron-down" style="font-size:9px;margin-left:2px"></i>' +
                        '</button>' +
                        '<div id="' + actPopupId + '" class="actions-popup popup-menu">' +
                            actItems +
                        '</div>' +
                    '</div>';
            }

            // Primary action button
            var primaryBtn = '';
            if (primaryAction) {
                var primaryPermAttr = primaryAction.permission
                    ? ' data-cf-permission="' + primaryAction.permission + '"'
                    : '';
                primaryBtn =
                    '<button class="tb-btn tb-btn-primary"' + primaryPermAttr +
                        ' onclick="CF.dataTable._onPrimaryAction(' + uid + ')">' +
                        (primaryAction.icon ? '<i class="' + primaryAction.icon + '"></i> ' : '') +
                        primaryAction.label +
                    '</button>';
            }

            // Filter button � only inject if page has #filter-body
            var hasFilter = injectOpts && injectOpts._hasFilter;
            var filterBtn = '';
            if (hasFilter) {
                filterBtn =
                    '<button class="tb-btn" id="dt-filter-btn-' + uid + '" onclick="openFilterModal()">' +
                        '<i class="fa-solid fa-sliders"></i> Filter' +
                        '<span class="filter-badge" id="filter-badge">0</span>' +
                    '</button>';
            }

            var html =
                '<div class="table-toolbar-top">' +
                    '<div class="toolbar-search">' +
                        '<i class="fa-solid fa-magnifying-glass"></i>' +
                        '<input type="text" id="' + searchId + '" placeholder="Search all columns\u2026"' +
                            ' oninput="CF.dataTable._onSearch(' + uid + ',this.value)" />' +
                    '</div>' +
                    '<div class="toolbar-actions">' +
                        '<div class="popup-wrap">' +
                            '<button class="tb-btn" onclick="togglePopup(\'' + colPopupId + '\')">' +
                                '<i class="fa-solid fa-table-columns"></i> Columns' +
                            '</button>' +
                            '<div id="' + colPopupId + '" class="col-toggle-popup popup-menu">' +
                                colItems +
                            '</div>' +
                        '</div>' +
                        filterBtn +
                        primaryBtn +
                        actionsBtn +
                    '</div>' +
                '</div>';

            card.insertAdjacentHTML('afterbegin', html);
        }

        // ?? Adopt existing toolbar from cshtml ??????????????
        function _adoptToolbarTop(toolbar, uid, columns, actions, injectOpts) {
            var searchInput = toolbar.querySelector('[data-cf-search]');
            if (searchInput) {
                searchInput.id = searchInput.id || ('dt-search-' + uid);
                searchInput.addEventListener('input', function () {
                    CF.dataTable._onSearch(uid, this.value);
                });
            }

            var colPopup = toolbar.querySelector('[data-cf-col-popup]');
            if (colPopup) {
                colPopup.id = colPopup.id || ('dt-col-popup-' + uid);

                var tableEl     = toolbar.closest('.table-card').querySelector('table');
                var headerCells = tableEl ? tableEl.querySelectorAll('thead th') : [];

                columns.forEach(function (col, i) {
                    var thEl  = headerCells[i];
                    var title = (thEl ? thEl.textContent.trim() : '') || col.title || '';
                    if (!title) return;

                    var label      = document.createElement('label');
                    label.className = 'col-toggle-item';
                    var cb         = document.createElement('input');
                    cb.type        = 'checkbox';
                    cb.checked     = true;
                    cb.addEventListener('change', function () {
                        CF.dataTable._toggleColumn(uid, i, this.checked);
                    });
                    label.appendChild(cb);
                    label.appendChild(document.createTextNode(title));
                    colPopup.appendChild(label);
                });

                var colBtn = toolbar.querySelector('[data-cf-col-toggle]');
                if (colBtn) {
                    colBtn.addEventListener('click', function (e) { e.stopPropagation(); togglePopup(colPopup.id); });
                }
            }

            var filterBtn = toolbar.querySelector('[data-cf-filter-btn]');
            if (filterBtn) {
                filterBtn.addEventListener('click', function () { openFilterModal(); });
            }

            var primaryBtn = toolbar.querySelector('[data-cf-primary-action]');
            if (primaryBtn) {
                primaryBtn.addEventListener('click', function () {
                    CF.dataTable._onPrimaryAction(uid);
                });
                // Stamp permission code from JS config onto the cshtml-defined
                // button so CF.permission.applyGuards can hide it for users
                // who lack the permission.
                var pa = injectOpts && injectOpts._primaryAction;
                if (pa && pa.permission && !primaryBtn.hasAttribute('data-cf-permission')) {
                    primaryBtn.setAttribute('data-cf-permission', pa.permission);
                }
            }

            var actPopup = toolbar.querySelector('[data-cf-actions-popup]');
            if (actPopup && actions && actions.length) {
                actPopup.id = actPopup.id || ('dt-act-popup-' + uid);

                actions.forEach(function (a, idx) {
                    if (a.divider) {
                        var div = document.createElement('div');
                        div.className = 'pm-divider';
                        actPopup.appendChild(div);
                    } else {
                        var item      = document.createElement('div');
                        item.className = 'pm-item' + (a.danger ? ' danger' : '');
                        if (a.permission) item.setAttribute('data-cf-permission', a.permission);
                        item.innerHTML = '<span class="pm-icon"><i class="' + (a.icon || '') + '"></i></span>' + a.label;
                        item.addEventListener('click', function () { CF.dataTable._onAction(uid, idx); });
                        actPopup.appendChild(item);
                    }
                });

                var actBtn = toolbar.querySelector('[data-cf-actions-toggle]');
                if (actBtn) {
                    actBtn.addEventListener('click', function (e) { e.stopPropagation(); togglePopup(actPopup.id); });
                }
            }
        }

        // ?? Inject filter bar ???????????????????????????????
        function _injectFilterBar(card) {
            if (card.querySelector('#filter-bar')) return;
            var toolbar = card.querySelector('.table-toolbar-top');
            if (toolbar) toolbar.insertAdjacentHTML('afterend', '<div id="filter-bar"></div>');
        }

        // ?? Inject row context menu ?????????????????????????
        function _injectRowContextMenu(uid, rowActions) {
            if (!rowActions || !rowActions.length) return;

            var existingMenu = document.getElementById('row-ctx-menu');
            if (existingMenu) existingMenu.remove();

            var items = '';
            rowActions.forEach(function (ra) {
                if (ra.divider) {
                    items += '<div class="pm-divider"></div>';
                } else {
                    // permission attribute lets CF.permission.applyGuards
                    // hide row actions the user can't perform.
                    var permAttr = ra.permission
                        ? ' data-cf-permission="' + ra.permission + '"'
                        : '';
                    items += '<div class="pm-item' + (ra.danger ? ' danger' : '') + '"' + permAttr +
                        ' onclick="CF.dataTable._onRowAction(' + uid + ',\'' + ra.action + '\')">' +
                        '<span class="pm-icon"><i class="' + (ra.icon || '') + '"></i></span>' +
                        ra.label +
                    '</div>';
                }
            });

            document.body.insertAdjacentHTML('beforeend', '<div id="row-ctx-menu">' + items + '</div>');
        }

        // ?? Inject toolbar bottom ???????????????????????????
        function _injectToolbarBottom(card, uid, defaultLen) {
            if (card.querySelector('.table-toolbar-bottom')) return null;

            var pageSizeId   = 'dt-page-size-' + uid;
            var rowInfoId    = 'dt-row-info-'   + uid;
            var paginationId = 'dt-pagination-' + uid;

            var options     = CF.appConfig.pagination.pageSizeOptions;
            var optionsHtml = options.map(function (s) {
                return '<option value="' + s + '"' + (s === defaultLen ? ' selected' : '') + '>' + s + '</option>';
            }).join('');

            var html =
                '<div class="table-toolbar-bottom">' +
                    '<div class="toolbar-row-info">' +
                        '<div class="page-size-wrap">' +
                            'Show ' +
                            '<select class="page-size-select" id="' + pageSizeId + '"' +
                                ' onchange="CF.dataTable._onPageSizeChange(' + uid + ',this.value)">' +
                                optionsHtml +
                            '</select>' +
                            ' entries' +
                        '</div>' +
                        '<span id="' + rowInfoId + '"></span>' +
                    '</div>' +
                    '<div class="toolbar-pagination" id="' + paginationId + '"></div>' +
                '</div>';

            var tableWrap = card.querySelector('.table-wrap');
            if (tableWrap) {
                tableWrap.insertAdjacentHTML('afterend', html);
            } else {
                card.insertAdjacentHTML('beforeend', html);
            }

            return {
                _uid:             uid,
                paginationWrapId: paginationId,
                rowInfoId:        rowInfoId,
                pageSizeSelectId: pageSizeId
            };
        }

        // ?? Inject filter modal shell ???????????????????????
        function _injectFilterModalShell() {
            if (document.getElementById('modal-overlay')) return;

            var filterBody = document.getElementById('filter-body');
            if (!filterBody) return;

            var bodyContent = filterBody.innerHTML;
            filterBody.remove();

            var html =
                '<div id="modal-overlay" onclick="onOverlayClick(event)">' +
                    '<div class="modal-box">' +
                        '<div class="modal-header">' +
                            '<div class="modal-header-title"><i class="fa-solid fa-sliders"></i> Advanced Filter</div>' +
                            '<button class="modal-close" onclick="closeFilterModal()"><i class="fa-solid fa-xmark"></i></button>' +
                        '</div>' +
                        '<div class="modal-body">' +
                            bodyContent +
                        '</div>' +
                        '<div class="modal-footer">' +
                            '<button onclick="resetAllFilters(true)" class="tb-btn tb-btn-reset">' +
                                '<i class="fa-solid fa-rotate-left"></i> Reset All' +
                            '</button>' +
                            '<div class="modal-filter-actions">' +
                                '<button onclick="closeFilterModal()" class="tb-btn">Cancel</button>' +
                                '<button onclick="applyFilters()" class="tb-btn tb-btn-primary"><i class="fa-solid fa-check"></i> Apply Filter</button>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                '</div>';

            document.body.insertAdjacentHTML('beforeend', html);
        }

        // ?? Auto-resize observer ????????????????????????????
        function _attachResizeObserver(dtInstance) {
            var timer = null;
            function adjust() {
                clearTimeout(timer);
                timer = setTimeout(function () { if (dtInstance) dtInstance.columns.adjust(); }, 80);
            }
            var mainWrapper = document.querySelector('.main-wrapper');
            if (mainWrapper && typeof ResizeObserver !== 'undefined') {
                new ResizeObserver(adjust).observe(mainWrapper);
            }
            window.addEventListener('resize', adjust);
        }

        // ?? Apply column widths (DataTables instance) ???????
        function _applyColumnWidths(dtInstance, columns) {
            if (!dtInstance || !columns) return;
            var tableNode   = dtInstance.table().node();
            var headerCells = tableNode.querySelectorAll('thead th');
            var totalMinPx  = 0;
            columns.forEach(function (col, i) {
                var mw = parseInt(col.minWidth, 10);
                if (mw > 0) {
                    totalMinPx += mw;
                    if (headerCells[i]) headerCells[i].style.minWidth = col.minWidth;
                }
            });
            if (totalMinPx > 0) tableNode.style.minWidth = totalMinPx + 'px';
        }

        // ?? Apply column widths (raw table, no DataTables) ??
        function _applyColumnWidthsRaw(tableEl, columns) {
            if (!tableEl || !columns) return;
            var headerCells = tableEl.querySelectorAll('thead th');
            var totalMinPx  = 0;
            columns.forEach(function (col, i) {
                var mw = parseInt(col.minWidth, 10);
                if (mw > 0) {
                    totalMinPx += mw;
                    if (headerCells[i]) headerCells[i].style.minWidth = col.minWidth;
                }
                if (col.width && headerCells[i]) headerCells[i].style.width = col.width;
            });
            if (totalMinPx > 0) tableEl.style.minWidth = totalMinPx + 'px';
        }

        // ?? Inject skeleton tbody rows ??????????????????????
        function _injectSkeletonRows(tableEl) {
            var tbody = tableEl.querySelector('tbody');
            if (tbody) CF.skeleton.table(tbody);
        }

        // ?? Sort header setup (server-side) ?????????????????
        function _initSortHeaders(tableEl, uid, columns) {
            tableEl.querySelectorAll('thead th').forEach(function (th, i) {
                var col = columns[i];
                if (!col) return;
                if (th.classList.contains('no-sort')) return;
                if (col.orderable === false || col.sortable === false) return;
                if (!col.sortField) return;

                th.classList.add('dt-server-sortable');
                th.dataset.colIdx    = i;
                th.dataset.sortField = col.sortField || '';
                th.dataset.sortDir   = '';
                th.addEventListener('click', function () { _onHeaderSort(uid, this); });
            });
        }

        function _onHeaderSort(uid, th) {
            var r = _registry[uid];
            if (!r || !r._serverCtx) return;

            var field = th.dataset.sortField;
            if (!field) return;

            var curDir = th.dataset.sortDir || '';
            var newDir = curDir === '' ? 'ASC' : curDir === 'ASC' ? 'DESC' : '';

            th.closest('table').querySelectorAll('thead th.dt-server-sortable').forEach(function (h) {
                h.dataset.sortDir = '';
                h.classList.remove('sorting_asc', 'sorting_desc');
            });

            th.dataset.sortDir = newDir;
            if (newDir === 'ASC')  th.classList.add('sorting_asc');
            if (newDir === 'DESC') th.classList.add('sorting_desc');

            r._serverCtx.onSort(newDir ? field : '', newDir);
        }

        // ??????????????????????????????????????????????????????
        // Client-side init (DataTables)
        // ??????????????????????????????????????????????????????
        function init(selector, dtOptions) {
            var tableEl = document.querySelector(selector);
            if (!tableEl) return null;

            var card = tableEl.closest('.table-card');
            if (!card) return null;

            var uid        = ++_tableCounter;
            var defaultLen = dtOptions.pageLength || CF.appConfig.pagination.defaultPageSize;
            var callerDrawCallback = dtOptions.drawCallback;
            var instance;
            var hasFilter = !!document.getElementById('filter-body');

            _injectSkeletonRows(tableEl);

            _registry[uid] = {
                instance:      null,
                actions:       dtOptions.actions       || [],
                primaryAction: dtOptions.primaryAction || null,
                rowActions:    dtOptions.rowActions     || [],
                onRowAction:   dtOptions.onRowAction   || null,
                _tableEl:      tableEl
            };

            _injectToolbarTop(card, uid, dtOptions.columns || [], dtOptions.actions, {
                _hasFilter:     hasFilter,
                _primaryAction: dtOptions.primaryAction
            });
            if (hasFilter) {
                _injectFilterBar(card);
                _injectFilterModalShell();
            }
            _injectRowContextMenu(uid, dtOptions.rowActions);

            var footerIds = _injectToolbarBottom(card, uid, defaultLen) || {
                _uid: uid, paginationWrapId: '', rowInfoId: '', pageSizeSelectId: ''
            };

            // Apply permission guards in case CF.user is already loaded
            // (cache-hit path � _applyMeData ran before this script).
            // For cache-miss path, the cf:user-loaded listener below
            // re-applies guards once CF.user populates.
            if (typeof CF.permission !== 'undefined' && CF.permission.applyGuards) {
                CF.permission.applyGuards(card);
                var ctxMenu = document.getElementById('row-ctx-menu');
                if (ctxMenu) CF.permission.applyGuards(ctxMenu);
            }

            requestAnimationFrame(function () {
                setTimeout(function () {
                    var dtClean = $.extend({}, dtOptions);
                    delete dtClean.actions;
                    delete dtClean.rowActions;
                    delete dtClean.onRowAction;

                    var merged = $.extend({
                        pageLength: defaultLen,
                        paging:     true,
                        searching:  true,
                        info:       true,
                        dom:        'lrtip',
                        autoWidth:  false
                    }, dtClean, {
                        drawCallback: function () {
                            _renderFooter(instance, footerIds);
                            if (typeof callerDrawCallback === 'function') {
                                callerDrawCallback.call(this);
                            }
                        }
                    });

                    instance = $(selector).DataTable(merged);
                    _registry[uid].instance = instance;

                    if (footerIds.pageSizeSelectId) {
                        _buildPageSizeSelect(footerIds.pageSizeSelectId, defaultLen);
                    }

                    _renderFooter(instance, footerIds);
                    _applyColumnWidths(instance, dtOptions.columns);
                    _attachResizeObserver(instance);
                }, 300);
            });

            return {
                column:  function () { var i = _registry[uid].instance; return i ? i.column.apply(i, arguments)  : null; },
                columns: function () { var i = _registry[uid].instance; return i ? i.columns.apply(i, arguments) : null; },
                search:  function () { var i = _registry[uid].instance; return i ? i.search.apply(i, arguments)  : null; },
                draw:    function () { var i = _registry[uid].instance; return i ? i.draw.apply(i, arguments)    : null; },
                page:    function () { var i = _registry[uid].instance; return i ? i.page.apply(i, arguments)    : null; },
                row:     function () { var i = _registry[uid].instance; return i ? i.row.apply(i, arguments)     : null; },
                rows:    function () { var i = _registry[uid].instance; return i ? i.rows.apply(i, arguments)    : null; }
            };
        }

        // ??????????????????????????????????????????????????????
        // Server-side init
        // ??????????????????????????????????????????????????????
        function serverInit(selector, opts) {
            var loadFn  = opts.loadFn;
            var mapItem = opts.mapItem || function (item) { return item; };

            if (typeof loadFn !== 'function') {
                throw new Error('CF.dataTable.serverInit requires opts.loadFn');
            }

            var tableEl = document.querySelector(selector);
            if (!tableEl) return null;

            var card = tableEl.closest('.table-card');
            if (!card) return null;

            var uid        = ++_tableCounter;
            var defaultLen = opts.pageLength || CF.appConfig.pagination.defaultPageSize;
            var columns    = opts.columns || [];

            var _state = {
                search:   '',
                page:     1,
                pageSize: defaultLen,
                sortBy:   '',
                sortDir:  ''
            };

            var hasFilter = !!document.getElementById('filter-body');

            _injectSkeletonRows(tableEl);

            _registry[uid] = {
                instance:      null,
                actions:       opts.actions       || [],
                primaryAction: opts.primaryAction || null,
                rowActions:    opts.rowActions     || [],
                onRowAction:   opts.onRowAction   || null,
                _serverCtx:    null,
                _tableEl:      tableEl,
                _colHidden:    {}   // colIdx ? true means hidden
            };

            _injectToolbarTop(card, uid, columns, opts.actions, {
                _hasFilter:     hasFilter,
                _primaryAction: opts.primaryAction
            });
            if (hasFilter) {
                _injectFilterBar(card);
                _injectFilterModalShell();
            }
            _injectRowContextMenu(uid, opts.rowActions);

            var footerIds = _injectToolbarBottom(card, uid, defaultLen) || {
                _uid: uid, paginationWrapId: '', rowInfoId: '', pageSizeSelectId: ''
            };

            // Apply permission guards in case CF.user is already loaded
            // (cache-hit path � _applyMeData ran before this script).
            // For cache-miss path, the cf:user-loaded listener below
            // re-applies guards once CF.user populates.
            if (typeof CF.permission !== 'undefined' && CF.permission.applyGuards) {
                CF.permission.applyGuards(card);
                var ctxMenu = document.getElementById('row-ctx-menu');
                if (ctxMenu) CF.permission.applyGuards(ctxMenu);
            }

            _applyColumnWidthsRaw(tableEl, columns);
            _initSortHeaders(tableEl, uid, columns);

            _registry[uid]._serverCtx = {
                onSort: function (sortBy, sortDir) {
                    _state.sortBy  = sortBy;
                    _state.sortDir = sortDir;
                    _state.page    = 1;
                    _showSkeleton();
                    _load();
                }
            };

            function _showSkeleton() {
                var tbody = tableEl.querySelector('tbody');
                if (tbody) CF.skeleton.table(tbody);
            }

            // ?? Render server pagination footer ??????????????
            function _renderServerFooter(pagination) {
                var totalCount = (pagination && pagination.totalCount) || 0;
                var totalPages = (pagination && pagination.totalPages) || 1;
                var curPage    = ((pagination && pagination.page) || 1) - 1;
                var pageSize   = (pagination && pagination.pageSize) || _state.pageSize;
                var rowCount   = tableEl.querySelectorAll('tbody tr:not(.cf-sk-row)').length;
                var start      = totalCount === 0 ? 0 : (curPage * pageSize) + 1;
                var end        = Math.min(start + rowCount - 1, totalCount);

                var rowInfoEl = document.getElementById(footerIds.rowInfoId);
                if (rowInfoEl) {
                    rowInfoEl.textContent = totalCount === 0
                        ? 'No entries'
                        : 'Showing ' + start + '\u2013' + end + ' of ' + totalCount + ' entries';
                }

                var wrap = document.getElementById(footerIds.paginationWrapId);
                if (!wrap) return;

                var btns = '';
                btns += '<button class="pg-btn' + (curPage === 0 ? ' disabled' : '') + '" onclick="CF.dataTable._goPage(' + uid + ',0)" title="First"><i class="fa-solid fa-angles-left"></i></button>';
                btns += '<button class="pg-btn' + (curPage === 0 ? ' disabled' : '') + '" onclick="CF.dataTable._goPage(' + uid + ',' + (curPage - 1) + ')" title="Prev"><i class="fa-solid fa-angle-left"></i></button>';

                _pageRangeArr(curPage, totalPages).forEach(function (p) {
                    if (p === '\u2026') { btns += '<button class="pg-btn ellipsis">\u2026</button>'; return; }
                    btns += '<button class="pg-btn' + (p === curPage ? ' active' : '') +
                        '" onclick="CF.dataTable._goPage(' + uid + ',' + p + ')">' + (p + 1) + '</button>';
                });

                btns += '<button class="pg-btn' + (curPage >= totalPages - 1 || totalPages === 0 ? ' disabled' : '') + '" onclick="CF.dataTable._goPage(' + uid + ',' + (curPage + 1) + ')" title="Next"><i class="fa-solid fa-angle-right"></i></button>';
                btns += '<button class="pg-btn' + (curPage >= totalPages - 1 || totalPages === 0 ? ' disabled' : '') + '" onclick="CF.dataTable._goPage(' + uid + ',' + (totalPages - 1) + ')" title="Last"><i class="fa-solid fa-angles-right"></i></button>';

                wrap.innerHTML = btns;
            }

            // ?? Render table body from items ?????????????????
            function _renderServerRows(items) {
                var tbody = tableEl.querySelector('tbody');
                if (!tbody) return;

                if (!items || items.length === 0) {
                    var colSpan = columns.length || 1;
                    tbody.innerHTML = '<tr><td colspan="' + colSpan + '" class="cf-table-empty-cell">' +
                        '<i class="fa-solid fa-inbox"></i>No data found</td></tr>';
                    return;
                }

                var html = '';
                items.forEach(function (item) {
                    var rowData = mapItem(item);
                    html += '<tr>';
                    columns.forEach(function (col, colIdx) {
                        var hidden = _registry[uid]._colHidden[colIdx] ? ' style="display:none"' : '';
                        if (col.data === null || col.defaultContent !== undefined) {
                            html += '<td' + hidden + '>' + (col.defaultContent || '') + '</td>';
                        } else {
                            var val = Array.isArray(rowData)
                                ? rowData[colIdx]
                                : (col.data !== undefined ? rowData[col.data] : rowData[colIdx]);
                            if (val === undefined || val === null) val = '';
                            var rendered = (typeof col.render === 'function')
                                ? col.render(val, 'display', rowData, { row: 0, col: colIdx })
                                : val;
                            html += '<td' + hidden + '>' + rendered + '</td>';
                        }
                    });
                    html += '</tr>';
                });
                tbody.innerHTML = html;
            }

            var _lastItems = [];

            var handle = {
                uid: uid,

                loaded: function (items, pagination) {
                    _lastItems = items || [];
                    _renderServerRows(_lastItems);
                    _renderServerFooter(pagination);
                },

                reload: function (overrides) {
                    if (overrides) {
                        if (overrides.search   !== undefined) _state.search   = overrides.search;
                        if (overrides.page     !== undefined) _state.page     = overrides.page;
                        if (overrides.pageSize !== undefined) _state.pageSize = overrides.pageSize;
                        if (overrides.sortBy   !== undefined) _state.sortBy   = overrides.sortBy;
                        if (overrides.sortDir  !== undefined) _state.sortDir  = overrides.sortDir;
                    }
                    _showSkeleton();
                    _load();
                },

                getState: function () {
                    return {
                        search:   _state.search,
                        page:     _state.page,
                        pageSize: _state.pageSize,
                        sortBy:   _state.sortBy,
                        sortDir:  _state.sortDir
                    };
                },

                getItemByRowIndex: function (rowIdx) {
                    return _lastItems[rowIdx] || null;
                }
            };

            // Override onRowAction to extract data from _lastItems
            var origOnRowAction = opts.onRowAction;
            _registry[uid].onRowAction = function (action) {
                var node = null;
                var r    = _registry[uid];
                if (r && r._lastClickedBtn) {
                    var tr     = $(r._lastClickedBtn).closest('tr');
                    var rowIdx = tr.length ? tr.index() : -1;
                    if (rowIdx >= 0) node = _lastItems[rowIdx] || null;
                }
                if (typeof origOnRowAction === 'function') origOnRowAction(action, node);
            };

            function _load() {
                loadFn({
                    search:   _state.search,
                    page:     _state.page,
                    pageSize: _state.pageSize,
                    sortBy:   _state.sortBy,
                    sortDir:  _state.sortDir
                }, handle);
            }

            _registry[uid]._serverSearch = function (val) {
                var q = val.trim();
                if (q.length > 0 && q.length < 3) return;
                _state.search = q;
                _state.page   = 1;
                _showSkeleton();
                _load();
            };

            _registry[uid]._serverPageSize = function (val) {
                _state.pageSize = parseInt(val, 10);
                _state.page     = 1;
                _showSkeleton();
                _load();
            };

            _registry[uid]._serverGoPage = function (p) {
                if (p < 0) return;
                _state.page = p + 1;
                _showSkeleton();
                _load();
            };

            _load();
            return handle;
        }

        // ?? Public API ??????????????????????????????????????
        function goPage(dtInstance, p) {
            if (!dtInstance) return;
            var info = dtInstance.page.info();
            if (p < 0 || p >= info.pages) return;
            dtInstance.page(p).draw('page');
        }

        function changePageSize(dtInstance, val) {
            if (!dtInstance) return;
            dtInstance.page.len(parseInt(val, 10)).draw();
        }

        // ?? Internal callbacks (called from injected HTML) ??
        function _goPage(uid, p) {
            var r = _registry[uid];
            if (!r) return;
            if (r._serverGoPage) { r._serverGoPage(p); return; }
            if (r.instance) goPage(r.instance, p);
        }

        var _searchTimers = {};
        function _onSearch(uid, val) {
            var r = _registry[uid];
            if (!r) return;

            if (r._serverSearch) {
                clearTimeout(_searchTimers[uid]);
                _searchTimers[uid] = setTimeout(function () { r._serverSearch(val); }, 300);
                return;
            }

            if (!r.instance) return;
            var q = val.trim();
            if (q.length > 0 && q.length < 3) return;
            r.instance.search(q).draw();
        }

        function _onPageSizeChange(uid, val) {
            var r = _registry[uid];
            if (!r) return;
            if (r._serverPageSize) { r._serverPageSize(val); return; }
            if (r.instance) changePageSize(r.instance, val);
        }

        // ?? Column toggle ???????????????????????????????????
        // Client-side: delegates to DataTables .column().visible()
        // Server-side: DOM-based hide/show on <th> + <td>, state
        //              persisted in _colHidden so new rows respect it
        function _toggleColumn(uid, idx, visible) {
            var r = _registry[uid];
            if (!r) return;

            // Client-side DataTables
            if (r.instance) {
                r.instance.column(idx).visible(visible);
                return;
            }

            // Server-side: DOM-based column toggle
            if (!r._colHidden) r._colHidden = {};
            r._colHidden[idx] = !visible;

            var table = r._tableEl;
            if (!table) return;

            var ths = table.querySelectorAll('thead th');
            if (ths[idx]) ths[idx].style.display = visible ? '' : 'none';

            table.querySelectorAll('tbody tr').forEach(function (tr) {
                var tds = tr.querySelectorAll('td');
                if (tds[idx]) tds[idx].style.display = visible ? '' : 'none';
            });
        }

        function _onAction(uid, idx) {
            var r = _registry[uid];
            if (!r) return;
            var action = r.actions[idx];
            if (action && typeof action.onClick === 'function') action.onClick();
            document.querySelectorAll('.popup-menu.open').forEach(function (p) { p.classList.remove('open'); });
        }

        function _onPrimaryAction(uid) {
            var r = _registry[uid];
            if (!r || !r.primaryAction) return;
            if (typeof r.primaryAction.onClick === 'function') r.primaryAction.onClick();
        }

        function _onRowAction(uid, action) {
            var r = _registry[uid];
            if (!r) return;

            var rowData = null;
            if (r._lastClickedBtn && r.instance) {
                var row = $(r._lastClickedBtn).closest('tr');
                if (row.length) rowData = r.instance.row(row).data();
            }

            if (typeof r.onRowAction === 'function') r.onRowAction(action, rowData);

            closeRowMenu();
        }

        return {
            init:              init,
            serverInit:        serverInit,
            goPage:            goPage,
            changePageSize:    changePageSize,
            _goPage:           _goPage,
            _onPageSizeChange: _onPageSizeChange,
            _onSearch:         _onSearch,
            _toggleColumn:     _toggleColumn,
            _onAction:         _onAction,
            _onPrimaryAction:  _onPrimaryAction,
            _onRowAction:      _onRowAction
        };
    })();

    // ????????????????????????????????????????????????????????
    // Row Context Menu (singleton)
    // ????????????????????????????????????????????????????????
    window.openRowMenu = function (e, btn) {
        e.stopPropagation();
        var menu = document.getElementById('row-ctx-menu');
        if (!menu) return;

        for (var uid in _registry) {
            if (_registry.hasOwnProperty(uid)) _registry[uid]._lastClickedBtn = btn;
        }

        menu._sourceBtn = btn;

        var rect  = btn.getBoundingClientRect();
        var mh    = 160, mw = 190;
        var openUp = rect.bottom + mh > window.innerHeight;
        menu.style.top  = (openUp ? rect.top - mh - 4 : rect.bottom + 4) + 'px';
        menu.style.left = Math.min(rect.right - mw, window.innerWidth - mw - 8) + 'px';
        menu.classList.add('show');
    };

    window.closeRowMenu = function () {
        var menu = document.getElementById('row-ctx-menu');
        if (menu) menu.classList.remove('show');
    };

    // ????????????????????????????????????????????????????????
    // Re-apply permission guards to toolbar buttons + row context
    // menu when CF.user becomes available after a cache miss.
    // serverInit() runs at $(document).ready and may finish BEFORE
    // /api/v1/auth/me responds; on the cache-hit path CF.user is already
    // populated synchronously, so applyGuards inside _applyMeData
    // already saw the rendered toolbar. This listener covers the
    // cache-miss case.
    // ????????????????????????????????????????????????????????
    document.addEventListener('cf:user-loaded', function () {
        if (typeof CF.permission !== 'undefined' && CF.permission.applyGuards) {
            CF.permission.applyGuards(document);
        }
    });

    // ????????????????????????????????????????????????????????
    // togglePopup � shared popup toggle used by Columns,
    // Actions, and any other .popup-menu in the toolbar.
    // Closes all other open popups before opening the target.
    // ????????????????????????????????????????????????????????
    window.togglePopup = function (id) {
        var popup = document.getElementById(id);
        if (!popup) return;
        var isOpen = popup.classList.contains('open');
        document.querySelectorAll('.popup-menu.open').forEach(function (p) {
            p.classList.remove('open');
        });
        if (!isOpen) popup.classList.add('open');
    };

    // Close popups on outside click
    document.addEventListener('click', function (e) {
        if (!e.target.closest('.popup-wrap') && !e.target.closest('.popup-menu')) {
            document.querySelectorAll('.popup-menu.open').forEach(function (p) {
                p.classList.remove('open');
            });
        }
        if (!e.target.closest('#row-ctx-menu') && !e.target.closest('.kebab-btn')) {
            window.closeRowMenu();
        }
    });

})();
